import type { InferredEntity } from '@sites/entity-migrator';
import { createVersionedEntityWithDefaults } from '@sites/entity-migrator';

import { sectionSpecificV0Schema } from './v0';
import { sectionLegacySpecificV0Schema } from '../legacy/specific';
import { migrateLegacySpecificToV0 } from '../legacy/migration';

export const SpecificSectionEntitySchema = createVersionedEntityWithDefaults({
    versionMap: {
        0: { schema: sectionSpecificV0Schema },
    },
    latestVersion: 0,
    legacy: [{ name: 'web', schema: sectionLegacySpecificV0Schema, up: migrateLegacySpecificToV0 }],
});

export type SpecificSection = InferredEntity<typeof SpecificSectionEntitySchema>;
